<h1 mat-dialog-title>Landkreis {{ landkreis.bezeichnung }} editieren</h1>
<div mat-dialog-content>
    <kiene-autocomplete
        [apiUrl]="'lieferant/'"
        [kieneObject]="vetAmt"
        [placeholder]="'Zuständiges Veterinäramt'"
        (elementSelected)="setVetAmt($event)"
    ></kiene-autocomplete>
    <kiene-autocomplete
        [focus]="false"
        [apiUrl]="'lieferant/'"
        [kieneObject]="ueberwachungsbehoerde"
        [placeholder]="'Zuständige Landesbehörde'"
        (elementSelected)="setUeberwachungsbehoerde($event)"
    ></kiene-autocomplete>
</div>
<div mat-dialog-action>
    <button mat-flat-button color="accent" (click)="save()">Speichern</button>
</div>
